<template>
  <div class="show">
    <span  style="color: #1DA57A;">{{ props.data.username}}</span>
    <span> | </span>
    <span>{{props.data.typeText}}://{{props.data.host}}:{{props.data.port}}</span>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue';
import {TextFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";

const props = defineProps<{
  propName: string;
  widget: TextFieldType;
  info: WidgetInfo;
  data: any;
}>();
</script>

<style lang="scss" scoped>
.show {
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
}
</style>
